'use strict';
import firebase from 'firebase'
import common from './globalconfig/common.service'

const state = {
  audit_trail: {
    is_enabled: true
  },
  config_attendance: {
    show_history_enabled: true,
    is_correction_enabled: true
  },
  config: {
    subscriber_type: 0,
    edit_employee_code_enabled: false,
    edit_fullname_enabled: false,
    edit_job_position_enabled: false,
    edit_email_enabled: false
  },
  config_cms: {
    is_map_location_enabled: true,
    attendance_report: false
  },
  config_fr: {
    face_check_out_type: 0,
    face_check_in_type: 1
  },
  config_mobile: {
    widget_summary_type: 1
  },
  feature_activity: {
    is_enabled: true
  },
  feature_claim: {
    is_enabled: true
  },
  feature_health_check: {
    is_enabled: true
  },
  feature_leave: {
    is_enabled: true
  },
  feature_news_feed: {
    is_enabled: true,
    max_active_news: 5
  },
  feature_task_assignment: {
    is_enabled: true,
    is_spv_only: true
  },
  mobile_version: {
    android_min_version: '',
    android_latest_version: '',
    android_min_build: 0,
    android_latest_build: 0,
    ios_min_version: '',
    ios_latest_version: '',
    ios_min_build: 0,
    ios_latest_build: 0,
  },
  feature_overtime: {
    is_enabled: true
  },
  feature_team: {
    is_send_email_enabled: true,
    is_enabled: true
  },
  feature_payroll: {
    is_enabled: false
  },
  hris_odoo: {
    is_integrated: false,
    db_name: 'DB-HRIS-LIVE'
  }
}

const actions = {
  gcGetDataCompany(context, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        if (payload) {
          const result = await firebase.firestore().collection(payload.collection).doc(payload.companyId).get()
          if (result) {
            if (payload.isLogin) context.commit('setGlobalConfig', result.data())
            return resolve(result.data())
          }
        }
        reject(new Error('Fail To Load'))
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e.message)
        reject(new Error('Connection Error'))
      }
    })
  },
  ...common.actions
}

const mutations = {
  setGlobalConfig(state, payload) {
    state.globalConfig = payload
  },
  setParamGlobalConfig(state, payload) {
    state.gcParams = payload;
  },

}

const getters = {
  gcGetData: ({ globalConfig }) => (feature, key) => {
    const state = globalConfig
    if (state) if (state[feature]) if (state[feature][key]) return state[feature][key]
    return null
  },
  gcGetAll: ({ globalConfig }) => {
    return globalConfig
  },
  gcGetAllKeys: ({ globalConfig }) => {
    return Object.keys(globalConfig)
  },
  gcGetParams: ({ gcParams }) => {
    return gcParams
  }
}

export default { getters, actions, mutations, state }